import './tableAction.scss';

import cn from 'classnames';
import { ReactNode, useCallback } from 'react';

interface ITableActionProps {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  customClassName?: string;
}

const TableAction = ({
  iconLeft: IconLeft,
  iconRight: IconRight,
  text,
  onClick,
  disabled = false,
  customClassName,
}: ITableActionProps) => {
  const handleClick = useCallback(() => {
    if (disabled) return;

    if (onClick) onClick();
  }, [onClick, disabled]);

  return (
    <div
      className={cn('mm-common-table-action', customClassName && customClassName, {
        _is_disabled: disabled,
      })}
      onClick={handleClick}
    >
      {IconLeft && IconLeft}
      <span>{text}</span>
      {IconRight && IconRight}
    </div>
  );
};

export { TableAction };
